<div class="flex justify-between items-center">
    <div matSnackBarLabel class="flex gap-2 grow items-center">
        <myrtls-icon [ngClass]="'text-' + getSnackBarColor(data.type)" [icon]="getSnackBarIcon(data.type)"></myrtls-icon>
        <div>{{ data.description }}</div>
    </div>
    @if (data.actionLabel) {
        <div matSnackBarActions>
            <button mat-button [ngClass]="'text-' + getSnackBarColor(data.type)" matSnackBarAction (click)="hideSnackBar()">{{ data.actionLabel }}</button>
        </div>
    }
</div>
